<template>
    <div class="freetargetImage-box"><img :src='freetargetImage' alt="" /></div>    
</template>
<script>
import freetargetImage from '../../assets/images/freetarget.webp'
export default {
    name: 'FreetargetComp',
    data() {
        return {
            freetargetImage: freetargetImage,
        }
    },
}
</script>